import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMask from 'v-mask'
// import VueGtag from 'vue-gtag'
// import VueAnalytics from 'vue-analytics'
import Carousel3d from 'vue-carousel-3d'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Egg from '@/utils/egg'
import VueGtag from 'vue-gtag-conversion'
import VueFacebookPixel from 'vue-analytics-facebook-pixel'

gsap.registerPlugin(ScrollTrigger)

const egg = new Egg()
egg.AddCode('i,d,d,q,d', function () {
  location.replace('/humans.txt')
}).Listen()

Vue.use(VueMask)
Vue.use(Carousel3d)

// Use GA
// Vue.use(VueAnalytics, {
//   id: 'UA-173915928-1',
//   router
// })

// Use gtag
Vue.use(VueGtag, {
  id: 'AW-722872910', // Your Adwords ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: process.env.NODE_ENV !== 'production' (optional)
  debug: false // Whether or not display console log debugs (optional)
})

// Use fb pixel
Vue.use(VueFacebookPixel)

// Init fb pixel
Vue.analytics.fbq.init('975918532478228')

Vue.prototype.$gsap = gsap
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
